import { IRootState } from '@app/store';
import { createSelector } from '@ngrx/store';
import { projectFeature } from './project.reducer';

import { ILockValues, IProjectState } from '@shared/model/project';

export const selectProjectState = (state: IRootState) => state.project;

export const {
  selectId: selectProjectId,
  selectProjectState: selectProjectInfo,
  selectName: selectProjectName,
  selectCan_load_files: selectProjectFiles,
  selectCan_results_view: selectProjectResults,
  selectCan_view_rating: selectProjectRating,
  selectCan_balance_view: selectProjectBalance,
  selectCan_output_to_excel: selectProjectExel,
  selectNav_btn_click: selectNavBtnClick,
  selectProgress,
  selectProjectConfig,
  selectMax_variants: selectProjectMaxVariants,
  selectCalc_id: selectCalcID,
} = projectFeature;

export const selectCurrency = createSelector(selectProjectState, (project: IProjectState) => ({
  currency: project?.currency,
  currency_multiplication: project?.currency_multiplication,
}));

export const selectIsLock = createSelector(selectProjectState, (project: ILockValues) => ({
  block_sales_plan: false, //project.block_sales_plan,
  block_leasings: false, //project.block_leasings,
  block_purshaces: false, //project.block_special_modes,
  block_special_modes: false, //project.block_advanced_products,
  block_advanced_products: false, //project.block_advanced_products,
  block_lead_generation: false, //project.block_lead_generation,
  block_standard_taxes: false, //project.block_standard_taxes,
  block_schedule: false, //project.block_schedule,
  block_distribution_ransom_payment: false, //project.block_distribution_ransom_payment,
  credit_capitalization: false, //project.credit_capitalization,
  grace_period_credit: false, //project.grace_period_credit,
}));

export const selectTabs = createSelector(
  selectProjectState,
  ({ credits_tab, leasings_tab, own_capitals_tab, capexs_tab, working_capital_tab, venture_tab }: IProjectState) => ({
    credits_tab,
    leasings_tab,
    own_capitals_tab,
    capexs_tab,
    working_capital_tab,
    venture_tab,
  }),
);

export const selectProjectLogo = createSelector(projectFeature.selectLogo, (logo) => (logo?.file ? logo : null));
